import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as crypto from "crypto-js";
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LoginRegisterService } from '../login-register.service';
@Component({
  selector: 'app-confirmpassword',
  templateUrl: './confirmpassword.component.html',
  styleUrls: ['./confirmpassword.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConfirmpasswordComponent implements OnInit {
  submitted: boolean = false;
  token: string;
  setpassword: boolean = false;

  @ViewChild('setPasswordBtn') setPasswordBtn: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private loginRegisterService: LoginRegisterService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params?.token;
      this.setpassword = params?.setpassword || false;
    });
  }

  confirmPwdForm = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(6)]],
    confirmPassword: ['', Validators.required]
  }, {
    validator: this.mustMatch('password', 'confirmPassword')
  });

  validateConfirmPassword() {
    if (this.confirmPwdForm.get('confirmPassword')?.value?.length > this.confirmPwdForm?.get('password')?.value?.length) {
      this.setPasswordBtn.focus();
    }
  }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  ngOnInit() {
    this.loginRegisterService.currentUser.subscribe((res) => {
      if (res) {
        this.router.navigateByUrl('/dashboard/home');
      }
    });
  }

  get f() { return this.confirmPwdForm.controls; }

  confirmPwdSumbit() {
    this.submitted = true;
    if (this.confirmPwdForm.invalid) {
      return;
    }
    if (this.setpassword) {
      this.inviteAdminSetPassword();
    } else {
      this.forgotPassword();
    }
  }

  private inviteAdminSetPassword = function () {
    const obj = {
      token: this.token,
      password: this.confirmPwdForm.value.confirmPassword
    };
    // Prefer inline button spinner; skip global overlay
    this.ngxService.startLoader('loader-03');
    this.loginRegisterService.inviatedAdminRegister(obj, { headers: { 'skip-loader': 'true' } }).subscribe((response) => {
      this.ngxService.stopLoader('loader-03');
      if (response.ssolink) {
        window.location = response.ssolink;
        return;
      }
      this.toastr.success('Password has been changed successfully.', '', { timeOut: 2000 });
    }, (err) => {
      this.ngxService.stopLoader('loader-03');
      this.toastr.error(err?.error?.errors[0]?.error, 'Error', { timeOut: 2000 });
    });
  }

  private forgotPassword = function () {
    const obj = {
      token: this.token,
      password: this.confirmPwdForm.value.confirmPassword
    };
    // Prefer inline button spinner; skip global overlay on HTTP loader
    this.ngxService.startLoader('loader-03');
    obj.password = crypto.AES.encrypt(obj.password, "evaltrixSecret").toString();
    this.loginRegisterService.resetPassword(obj, { headers: { 'skip-loader': 'true' } }).subscribe(() => {
      this.ngxService.stopLoader('loader-03');
      this.router.navigateByUrl('/login/employerLogin');
      this.toastr.success('Password has been changed successfully.', '', { timeOut: 2000 });
    }, (err) => {
      this.ngxService.stopLoader('loader-03');
      this.toastr.error(err?.error?.errors[0]?.error, 'Error', { timeOut: 2000 });
    });
  }

}
